import { Infobulle } from './Infobulle';

/**
 * Civilité en icône : une silhouette d'homme ou de femme.
 *
 * Elle remplace « M. » / « Mme » dans les listes, où deux caractères de
 * texte se confondaient avec le prénom qui suit. Le libellé survit dans
 * l'infobulle et dans `aria-label` : une icône seule ne se lit pas au
 * lecteur d'écran, et une civilité inconnue ne doit pas devenir un
 * homme par défaut d'affichage.
 */
export function IconeCivilite({ civilite }: { civilite: string | null }) {
  if (civilite !== 'M' && civilite !== 'Mme') {
    return <span className="inline-block w-4 text-encre-300">—</span>;
  }

  const femme = civilite === 'Mme';
  const libelle = femme ? 'Madame' : 'Monsieur';

  return (
    <Infobulle texte={libelle} className="inline-flex">
      <svg
        viewBox="0 0 16 16"
        className={`h-4 w-4 shrink-0 ${femme ? 'text-rose-500' : 'text-sky-600'}`}
        fill="currentColor"
        role="img"
        aria-label={libelle}
      >
        <circle cx="8" cy="3.6" r="2.6" />
        {femme ? (
          // Une robe : un trapeze sous la tete, ourlet arrondi.
          <path d="M8 6.4c-1.7 0-2.6 1-3 2.4l-1.2 4.3c-.1.5.2.9.7.9h7c.5 0 .8-.4.7-.9l-1.2-4.3c-.4-1.4-1.3-2.4-3-2.4z" />
        ) : (
          // Un buste : epaules et torse droits.
          <path d="M8 6.4c-2.2 0-3.6 1.2-3.9 3.2l-.4 3.4c-.1.5.3 1 .8 1h7c.5 0 .9-.5.8-1l-.4-3.4C11.6 7.6 10.2 6.4 8 6.4z" />
        )}
      </svg>
    </Infobulle>
  );
}
